import address from './address.json';

export const enAu = {
  translation: {
    address,
  },
};
